<div class="heading skin-detail-heading" (resize)="handleResize($event)">
  @if (canGoBack()) {
    <app-button2 appearance="secondary-ghost" size="s" aria-label="Go back" (click)="handleGoBack()">
      <app-icon name="chevron-left" />
    </app-button2>
  }

  <app-color-input [control]="form.controls.color" appearance="sapphire" [size]="24" />

  <app-input
    class="input"
    appearance="sapphire-inline"
    [inputFormControl]="form.controls.title"
    placeholder="New Calendar"
    [errorPlaceholder]="'Add title'"
    [withErrors]="submitted"
    size="s"
  />

  <div class="icons">
    <div [appPreventDirtyClick]="dirtyFormRef" class="contents">
      <!-- [MUST-002] 'Bug' debug quick-action hidden per task; uncomment to re-enable
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="bug"
        [active]="selectedTab === 'debug'"
        matTooltip="Debug"
        (onClick)="selectedTab = 'debug'"
      />
      -->

      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-archive2"
        [active]="form.controls.archived.value"
        [matTooltip]="form.controls.archived.value ? Labels.RestoreFromArchive : Labels.Archive"
        [disabled]="!calendar?.id"
        (onClick)="archive()"
      />

      <stch-trash-action *ngIf="!contracted" [deleted]="form.controls.deleted.value" [disabled]="!calendar?.id" (onClick)="delete()" />

<!-- SBUX-785 v1: containers are not shareable (only leaf entities). Re-enable later.
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-share"
        matTooltip="Share"
        [disabled]="!calendar?.id"
        [stchShareContextMenu]="calendar"
        [stchShareContextMenuDisabled]="!calendar?.id"
      />
      -->

      <app-button
        appearance="sapphire-secondary-ghost"
        size="xs"
        icon="sapphire-ellipsis"
        matTooltip="More options"
        [disabled]="!calendar?.id"
        (appCalendarContextMenuDetails)="selectedTab = 'details'"
        [appCalendarContextMenu]="calendar"
        [appCalendarContextMenuDisabled]="!calendar?.id"
        appCalendarContextMenuMode="popover"
        [printEnabled]="true"
      />
    </div>

    @if (showCloseButton) {
      <app-button appearance="sapphire-secondary-ghost" size="xs" icon="sapphire-close" (click)="handleClose()" />
    }
  </div>
</div>

@if (!calendar?.id && workspaceIdentity(); as identity) {
  <app-tenancy-selector
    [spaceTitle]="identity.spaceTitle"
    [spaceTenantId]="identity.spaceTenantId"
    [memberTenantId]="identity.memberTenantId"
    itemNoun="calendar"
    [locked]="!!calendar?.accountId || form.controls.uploads.value.length > 0"
    [lockedReason]="calendar?.accountId ? 'This draft already belongs to a workspace.' : null"
    [(tenantId)]="sharingTenantId"
  />
}

<app-stitch-timestamps class="block" [createdAt]="calendar?.createdAt" [updatedAt]="calendar?.updatedAt" />

<div class="tabs skin-detail-tabs">
  <app-tabs appearance="sapphire" [values]="tabsWithCounts()" [(value)]="selectedTab" size="m" />

  <div class="filler"></div>

  <!-- [MUST-001] 'Assign' button hidden per task; uncomment to re-enable

  <app-button appearance="sapphire-secondary" size="xs" label="Assign" />

  -->
  <stch-knowledge-button [active]="displayKnowledge" (click)="showKnowledge()" />
</div>

<div
  *ngIf="form"
  class="form"
  appDroppable
  appDroppableHoverClass="drag-over"
  [appDroppableDisabled]="!stitchItem?.id"
  [appDroppablePredicate]="dndPredicate"
  (appDroppableDrop)="dndDrop($event)"
  [appDroppableZIndex]="0"
>
  <div class="drop-area-border"></div>

  @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
    <app-entity-hub-search [contactId]="calendar?.id" />
  }

  <div class="form-heading">
    <div class="form-heading-nav">

    </div>

    <div *ngIf="displayKnowledge" class="form-heading-nav-underline"></div>

    <!-- One Knowledge box, rows in the skin's order: Knots · Tags · Connections; on the Stitch tab, main's
         knowledge hub mode (#2481). -->
    <div class="form-knowledge" [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())">
      <app-knots
        class="form-knots"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="calendar | toArray"
        [control]="form.controls['knots']"
        [stateKey]="StateKey.knotsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="calendar?.id"
      />

      <app-tags
        class="form-tags"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="[calendar]"
        [control]="form.controls['tags']"
        [stateKey]="StateKey.tagsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="calendar?.id"
      />

      <app-connections
        class="form-knots"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="[calendar]"
        [control]="form.controls['connections']"
        [stateKey]="StateKey.connectionsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="calendar?.id"
      />
    </div>
  </div>

  <!-- stitch-app-shell ContainerItems: the list's sort & filter on a bar of its own right above the list, on
       the far right over a 1px line, so it reads as the list's (Johanna, 2026-10-21; it sat in the tab row). -->
  <div class="container-list-bar" *ngIf="selectedTab === 'calendar'">
    <app-context-menu-state-indicator svgIcon="filters" appEventsListContextMenu />
  </div>
  <app-scroll
    *ngIf="(selectedTab !== 'stitch' || (permissionsLoaded() && !hasKnowledgeHubAccess()))"
    [ngSwitch]="selectedTab"
    class="form-scroll"
    (top)="displayScrollShadow = !$event"
  >
    <div *ngIf="displayScrollShadow" class="form-scroll-shadow"></div>

    <ng-template #unsavedCalendarEventsTpl>
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg">
        <div class="flex max-w-full flex-col items-center gap-2">
          <p class="text-base font-medium text-gray-900 text-center">No events</p>
          <p class="text-sm text-gray-600 text-center">Save your calendar to start adding events</p>
        </div>
      </app-no-content-stub>
    </ng-template>

    <app-events-list
      *ngSwitchCase="'calendar'"
      class="h-full"
      [filters]="eventsFilters"
      [tenantItems]="tenantCarrier()"
      [notFoundTemplate]="calendar?.id ? undefined : unsavedCalendarEventsTpl"
      (clickEvent)="handleClickItem($event)"
      (doubleClickEvent)="handleDblClickItem($event)"
    />

    <div *ngSwitchCase="'details'" class="form-kit" [class.contracted]="contracted">
      <section class="form-kit-section">
        <div class="form-kit-field">
          <span class="form-kit-label">Timezone</span>
          <app-timezone-input

            [control]="form.controls.timeZone"
            placeholder="Select Time Zone"
            appearance="sapphire"
            [caption]="tzSeeder.caption()"
          />
        </div>

        @if (false) {
          <!-- HIDDEN FOR VERSION 1-->
          <div class="form-kit-field">
            <span class="form-kit-label">Parent Calendar</span>
            <app-autocomplete-input
              appearance="sapphire-outline"
              placeholder="Parent Calendar"
              [suggestions]="parentSuggestions"
              [inputFormControl]="form.controls.parentId"
              size="s"
              [withErrors]="submitted"
              [validationMessages]="{
                circular: 'Circular dependency',
                deep: 'Too deep',
              }"
              [withClear]="true"
            />
          </div>
        }
      </section>

      <section class="form-kit-section">
        <stch-item-description-field
          [control]="form.controls.description"
          [item]="calendar"
          [tagsControl]="form.controls['tags']"
          [knotsControl]="form.controls['knots']"
        />
      </section>
    </div>

    <app-attachments-list
      class="form-attachments h-full"
      *ngSwitchCase="'attachments'"
      [stitchItem]="stitchItem"
      [inputControl]="form.controls.uploads"
      [tenantItems]="tenantCarrier()"
      [contextMenuStateVariant]="attachmentsMenuStateVariant"
      (listStateChange)="attachmentsListState = $event"
      (uploading)="onUploadingChange($event)"
      (onClickItem)="handleClickItem($event)"
      (onDblClickItem)="handleDblClickItem($event)"
    />

    <app-context-menu-state-indicator
      *ngSwitchCase="'stitch'"
      class="block ml-auto w-fit mt-5 mr-4"
      svgIcon="filters"
      appStitchListContextMenu
      (appStitchListContextMenuChange)="stitchListState = $event"
    />

    <app-linked-info-list
      *ngSwitchCase="'stitch'"
      class="form-linked-info h-full"
      [stitch]="calendar"
      [state]="stitchListState"
      [placeholderSubtitle]="calendar?.id ? undefined : 'Save to start Stitching items'"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />

    <stch-comments *ngSwitchCase="'comments'" class="form-linked-info h-full" [stitch]="calendar" />

    <stch-json-viewer class="h-full" *ngSwitchCase="'debug'" [json]="calendar?.debug" />
  </app-scroll>

  @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
    <app-stitch-hub
      [stitch]="calendar"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />
  }

  <stch-save-cancel-panel
    [enabled]="!pristine"
    [uploading]="isUploading()"
    (onCancel)="handleCancel()"
    (onSave)="handleSubmit()"
  />

</div>

<!-- stitch-app-shell breadcrumbs footer in the main view, as on every detail page. -->
@if (navigation.enabled && stitchItem?.id) {
  <app-detail-breadcrumbs
    [crumbs]="breadcrumbs()"
    [status]="form.controls.archived.value ? 'Archived' : form.controls.deleted.value ? 'Trash' : undefined"
  />
}
